import momentTz from "moment-timezone";
import { useStore as useAuthStore } from "auth/store";

export const useCurrentUserTimezone = () => {
  const {
    state: { user },
  } = useAuthStore();
  const userTimezone = user?.timezone || momentTz.tz.guess();
  return userTimezone;
};
